import React from 'react';
import Seo from '../components/Seo';
import WebinarBanner from '../components/WebinarBanner';
import HeroSection from '../components/HeroSection';
import TrustedBy from '../components/TrustedBy';
import FeaturesSection from '../components/FeaturesSection';
import SolutionsShowcase from '../components/SolutionsShowcase';
import TeamBenefitsSection from '../components/TeamBenefitsSection';
import ResourcesSection from '../components/ResourcesSection';
import CTASection from '../components/CTASection';

const ModernHome = () => {
  return (
    <>
      <Seo title="Home" />
      <WebinarBanner />
      <HeroSection />
      <TrustedBy />
      <FeaturesSection />
      <SolutionsShowcase />
      <TeamBenefitsSection />
      <ResourcesSection />
      <CTASection />
    </>
  );
};

export default ModernHome;


